import { useState, useEffect } from 'react';
import _ from 'lodash';

/**
 * @param {*} updatedSubmissionVMValue submission dto
 * @param {*} isPageInitialized submission dto
 * @returns {*} isDirty boolean
 */
function useCheckSubmissionVMDirty (updatedSubmissionVMValue, isPageInitialized = true) {
    const [originalSubmissionVMValue, setOriginalSubmissionVMValue] = useState(undefined);
    const [isPageDirty, setIsPageDirty] = useState(false);

    useEffect(() => {
        if(isPageInitialized) {
            if(_.isUndefined(originalSubmissionVMValue)) {
                setOriginalSubmissionVMValue(_.cloneDeep(updatedSubmissionVMValue));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPageInitialized]);

    const checkIfDirty = () => {
        if(isPageDirty === true){
            return isPageDirty;
        }
        const pageDirty = () => {
            if(!_.isUndefined(originalSubmissionVMValue)){
                return !_.isEqual(originalSubmissionVMValue, updatedSubmissionVMValue);
            }
            return false;
        };

        if(pageDirty() === true){
            setIsPageDirty(pageDirty);
        }
        return isPageDirty;
    };
    
    const returnDirty = checkIfDirty();
    return { isDirty: returnDirty };
};

function useCheckSubmissionVMWithEntityDirty (updatedSubmissionVMValue, updatedEntityVM, isPageInitialized = true) {
    const [originalSubmissionVMValue, setOriginalSubmissionVMValue] = useState(undefined);
    const [originalEntityVMValue, setOriginalEntityVMValue] = useState(undefined);
    const [isPageDirty, setIsPageDirty] = useState(false);

    useEffect(() => {
        if(isPageInitialized) {
            if(_.isUndefined(originalSubmissionVMValue)) {
                setOriginalSubmissionVMValue(_.cloneDeep(updatedSubmissionVMValue));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPageInitialized]);

    const setEntityVMValue = () => {
        if(_.isUndefined(originalEntityVMValue)){
            if(!_.isUndefined(_.get(updatedEntityVM, 'value.fieldsMetadata'))){
                setOriginalEntityVMValue(_.cloneDeep(updatedEntityVM.value));
            }
        }
    };

    const checkIfDirty = () => {
        if(isPageDirty === true){
            return isPageDirty;
        }
        const pageDirty = () => {
            if(!_.isUndefined(originalSubmissionVMValue) && !_.isUndefined(originalEntityVMValue)){
                return !_.isEqual(originalSubmissionVMValue, updatedSubmissionVMValue) || 
               !_.isEqual(originalEntityVMValue, updatedEntityVM.value);
            }
            return false;
        };

        if(pageDirty() === true){
            setIsPageDirty(pageDirty);
        }
        return isPageDirty;
    };

    setEntityVMValue();
    const returnDirty = checkIfDirty();
    return { isDirty: returnDirty };
};

function useCheckSubmissionVMWithEntitiesDirty (updatedSubmissionVMValue, updatedEntitiesVM, isPageInitialized) {
    const [originalSubmissionVMValue, setOriginalSubmissionVMValue] = useState({});
    const [originalEntitiesVMValue, setOriginalEntitiesVMValue] = useState(undefined);
    const [isPageDirty, setIsPageDirty] = useState(false);

    useEffect(() => {
        setOriginalSubmissionVMValue(_.cloneDeep(updatedSubmissionVMValue));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setEntitiesVMValue = () => {
        if(isPageInitialized === true) {
            if(_.isUndefined(originalEntitiesVMValue)){
                if(updatedEntitiesVM.length > 0 && updatedEntitiesVM.every((entity) => !_.isUndefined(_.get(entity, 'value.fieldsMetadata')))){
                    const originalEntitiesValue = [];
                    updatedEntitiesVM.forEach((entityValue) => {
                        originalEntitiesValue.push(_.cloneDeep(entityValue.value));
                    });
                    setOriginalEntitiesVMValue([...originalEntitiesValue]);
                    // replacing with the latest copy when the originalEnities is set
                    setOriginalSubmissionVMValue(_.cloneDeep(updatedSubmissionVMValue));
                }
            }
        }
    };

    const checkIfDirty = () => {
        if(isPageDirty === true){
            return isPageDirty;
        }
        const pageDirty = () => {
            if(!_.isUndefined(originalSubmissionVMValue) && !_.isUndefined(originalEntitiesVMValue)){
                if(originalEntitiesVMValue.length !== updatedEntitiesVM.length ){
                    return true;
                }
                if( updatedEntitiesVM.length > 0 && updatedEntitiesVM.every((entity) => !_.isUndefined(_.get(entity, 'value.fieldsMetadata')))){
                    const updatedEntitiesValue = [];
                    updatedEntitiesVM.forEach((entityValue) => {
                        updatedEntitiesValue.push(_.cloneDeep(entityValue.value));
                    });
                    const submissionTest = !_.isEqual(originalSubmissionVMValue, updatedSubmissionVMValue);
                    const entityTest=  !_.isEqual(originalEntitiesVMValue, updatedEntitiesValue);
                    return entityTest || submissionTest ;
                }
            }
            return false;
        };

        if(pageDirty() === true){
            setIsPageDirty(pageDirty);
        }
        return isPageDirty;
    };

    setEntitiesVMValue();
    const returnDirty = checkIfDirty();
    return { isDirty: returnDirty,
        setIsPageDirty };
};

export { useCheckSubmissionVMWithEntityDirty, useCheckSubmissionVMWithEntitiesDirty, useCheckSubmissionVMDirty} ; 